"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FormOptionChip", {
  enumerable: true,
  get: function get() {
    return _FormOptionChip["default"];
  }
});
var _FormOptionChip = _interopRequireDefault(require("./FormOptionChip"));